import {
  Box,
  Grid,
  TextField,
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Checkbox,
  Button,
  Modal,
  Autocomplete,
} from "@mui/material";
import { Controller, useForm, useWatch, useFieldArray } from "react-hook-form";
import React, { useEffect, useState } from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import OAuth2Authenticator from "../Auth2Authenticator/OAuth2Authenticator";
import {
  getSettings,
  upsertSetting,
} from "../../../../APICalling/OtherCalling";
import { EXTENSION_IDENTIFIER } from "../../../../config/serviceConstant";
import { getOpenSnakErrorData } from "../../../../config/otherConstant";
import { SCOPE_SEPERATORS } from "../../../../config/scope";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const CustomConnection = ({
  orgId,
  apiKey,
  dataCenter,
  zApiKey,
  setSnack,
  currentUser,
  handlefetchConnections,
  setConnection,
}) => {
  const [service, setService] = useState();
  const [serviceAuth, setServiceAuth] = useState(false);
  const [open, setOpen] = useState(false);
  const [submitData, setSubmitData] = useState();
  const [settingId, setSettingId] = useState();
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { handleSubmit, control, reset, getValues, setValue } = useForm({
    defaultValues: {
      connName: "",
      connApiName: "",
      parameterType: "Headers",
      authType: "OAuth2",
      grantType: "Authorization Code",
      scopes: [],
      dynamicParams: [],
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "scopes",
  });

  const {
    fields: dynamicParamfields,
    append: dynamicParamAppend,
    remove: dynamicParamRemove,
  } = useFieldArray({
    control,
    name: "dynamicParams",
  });

  const scopsWatch = useWatch({
    control,
    name: "scopes",
  });

  // useEffect(() => {
  //   setValue(
  //     "connApiName",
  //     getValues("connName")?.split(" ")?.join("_")?.split("__")?.join("_")
  //   );
  // }, [getValues("connName")]);

  const onSubmit = async (data) => {
    console.log({ data });

    let testData = {
      ...data,
      parameterType: "Headers",
      authType: "OAuth2",
      grantType: "Authorization Code",
    };

    let queryParams = {};
    data?.dynamicParams?.forEach((dynamicParam) => {
      queryParams[dynamicParam?.displayName] = dynamicParam?.name;
    });

    let service = {
      name: testData?.connName,
      serviceConnection:
        process.env.REACT_APP_EXTENSION_IDENTIFIER + "__custom",
      authorizeUrl: testData?.authorizeUrl,
      clientId: testData?.clientId,
      clientSecret: testData?.clientSecret,
      authType: "OAuth2",
      refreshTokenUrl: testData?.refreshTokenUrl,
      accessTokenUrl: testData?.accessTokenUrl,
      revokeUrl: testData?.revokeUrl,
      scopes: testData?.scopes,
      scopeSeperator: testData?.scopeSeperator?.value,
      queryParams: queryParams,
    };

    setService((prev) => service);

    let tempData = {
      scopes: testData?.scopes?.map((scope) => {
        return {
          scope: { ...scope },
          value: true,
        };
      }),
      connName: testData?.connName,
      connApiName: testData?.connApiName,
    };

    // create setting
    let headers = {
      orgId,
      apiKey,
      connname: EXTENSION_IDENTIFIER,
    };
    let bodyData = {
      settingSchema: {
        service,
        data: tempData,
      },
      moduleApiName: data?.connApiName,
      settingType: "customConnection",
    };
    let params = { moduleApiName: data?.connApiName };
    const previousSettings = await getSettings({ headers, params });
    if (previousSettings?.data) {
      // todo show error regarding same api name
      setSnack(
        getOpenSnakErrorData("Error!!! Duplicate Connection Name", 10 * 1000)
      );
      return;
    }

    const settingResp = await upsertSetting({ headers, data: bodyData });
    console.log({ settingResp: settingResp?.data?.setting_id });

    setSettingId((prev) => settingResp?.data?.setting_id);
    let scopes = data?.scopes?.map((socopeCheckbox) => socopeCheckbox?.name);
    let tempSubmitData = {
      ...tempData,
      scopes,
    };
    setSubmitData((prev) => tempSubmitData);
    setOpen((prev) => true);
    /*
     */
  };

  return (
    <Box pl={10} pt={5} sx={{ width: "80%" }}>
      <Box>
        <Box display={"flex"}>
          <ArrowBackIosIcon
            sx={{ color: "#757575", "&:hover": { color: "black" } }}
            onClick={() => setConnection((prev) => "list")}
          />
          <Typography sx={{ fontWeight: "bold", fontSize: "16px" }}>
            Create Service
          </Typography>
        </Box>
        <Box>
          <Typography
            sx={{
              fontSize: "12px",
              color: "text.secondary",
              width: "98%",
            }}
          >
            Provide the following service details and click 'Create Service'.
            Once configured, you can create multiple connections based on this
            service.
          </Typography>
        </Box>
      </Box>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid pt={3} container spacing={2}>
          <Grid item xs={5.2} sm={5.2} md={5.2} mb={1}>
            <Typography sx={{ fontSize: "15px" }}>Service Name</Typography>
            <Controller
              name="connName"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <>
                  <TextField
                    id="standard-basic"
                    size={"small"}
                    variant="outlined"
                    required
                    {...field}
                    onChange={(event) => {
                      // if (!event?.target?.checked) {
                      //   setValue('information.saveFolder.value', null);
                      // }
                      // setValue(`information.saveFolder.value`, null);
                      // reset({
                      //   firstName: "bill",
                      //   lastName: "luo",
                      // })
                      // resetField("information.saveFolder.value")
                      // setValue("information.saveFolder.value", null);
                      field.onChange(event?.target?.value);
                      setValue(
                        "connApiName",
                        event?.target?.value
                          ?.split(" ")
                          ?.filter((data) => data)
                          ?.join("_")
                          ?.split("_")
                          ?.filter((data) => data)
                          ?.join("_")
                      );
                    }}
                    fullWidth
                  />
                </>
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} mb={1}>
            <Typography sx={{ fontSize: "15px" }}>Service Link Name</Typography>

            <Controller
              name="connApiName"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <>
                  <TextField
                    id="standard-basic"
                    size={"small"}
                    variant="outlined"
                    disabled
                    required
                    {...field}
                    fullWidth
                  />
                </>
              )}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2} mb={1}>
          <Grid item xs={5.2} sm={5.2} md={5.2}>
            <Typography sx={{ fontSize: "15px" }}>
              Authentication Type
            </Typography>
            <Controller
              name="authType"
              control={control}
              disabled
              rules={{ required: true }}
              render={({ field }) => (
                <>
                  <TextField
                    id="standard-basic"
                    size={"small"}
                    disabled
                    variant="outlined"
                    required
                    {...field}
                    onChange={(event) => {
                      field.onChange(event?.target?.value);
                    }}
                    fullWidth
                  />
                </>
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Typography sx={{ fontSize: "15px" }}>Parameter Type</Typography>

            <Controller
              name="parameterType"
              control={control}
              disabled
              rules={{ required: true }}
              render={({ field }) => (
                <>
                  <TextField
                    id="standard-basic"
                    disabled
                    variant="outlined"
                    size={"small"}
                    required
                    {...field}
                    onChange={(event) => {
                      field.onChange(event?.target?.value);
                    }}
                    fullWidth
                  />
                </>
              )}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2} mb={1}>
          <Grid item xs={5.2} sm={5.2} md={5.2}>
            <Typography sx={{ fontSize: "15px" }}>Grant Type</Typography>
            <Controller
              name="grantType"
              control={control}
              disabled
              rules={{ required: true }}
              render={({ field }) => (
                <>
                  <TextField
                    id="standard-basic"
                    size={"small"}
                    disabled
                    variant="outlined"
                    required
                    {...field}
                    onChange={(event) => {
                      field.onChange(event?.target?.value);
                    }}
                    fullWidth
                  />
                </>
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Typography sx={{ fontSize: "15px" }}>Revoke URL</Typography>
            <Controller
              name="revokeUrl"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <>
                  <TextField
                    id="standard-basic"
                    size={"small"}
                    variant="outlined"
                    required
                    {...field}
                    onChange={(event) => {
                      field.onChange(event?.target?.value);
                    }}
                    fullWidth
                  />
                </>
              )}
            />
          </Grid>
        </Grid>

        <Grid container spacing={2} mb={1}>
          <Grid item xs={5.2} sm={5.2} md={5.2}>
            <Typography sx={{ fontSize: "15px" }}>Client ID</Typography>
            <Controller
              name="clientId"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <>
                  <TextField
                    id="standard-basic"
                    size={"small"}
                    variant="outlined"
                    required
                    {...field}
                    onChange={(event) => {
                      field.onChange(event?.target?.value);
                    }}
                    fullWidth
                  />
                </>
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Typography sx={{ fontSize: "15px" }}>Client Secret</Typography>

            <Controller
              name="clientSecret"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <>
                  <TextField
                    id="standard-basic"
                    variant="outlined"
                    size={"small"}
                    required
                    {...field}
                    onChange={(event) => {
                      field.onChange(event?.target?.value);
                    }}
                    fullWidth
                  />
                </>
              )}
            />
          </Grid>
        </Grid>

        <Grid container spacing={2} mb={1}>
          <Grid item xs={5.2} sm={5.2} md={5.2}>
            <Typography sx={{ fontSize: "15px" }}>Authorize URL</Typography>
            <Controller
              name="authorizeUrl"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <>
                  <TextField
                    id="standard-basic"
                    size={"small"}
                    variant="outlined"
                    required
                    {...field}
                    onChange={(event) => {
                      field.onChange(event?.target?.value);
                    }}
                    fullWidth
                  />
                </>
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Typography sx={{ fontSize: "15px" }}>Access Token URL</Typography>

            <Controller
              name="accessTokenUrl"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <>
                  <TextField
                    id="standard-basic"
                    variant="outlined"
                    size={"small"}
                    required
                    {...field}
                    onChange={(event) => {
                      field.onChange(event?.target?.value);
                    }}
                    fullWidth
                  />
                </>
              )}
            />
          </Grid>
        </Grid>

        <Grid container spacing={2} mb={1}>
          <Grid item xs={5.2} sm={5.2} md={5.2}>
            <Typography sx={{ fontSize: "15px" }}>Refresh Token URL</Typography>
            <Controller
              name="refreshTokenUrl"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <>
                  <TextField
                    id="standard-basic"
                    size={"small"}
                    variant="outlined"
                    required
                    {...field}
                    onChange={(event) => {
                      field.onChange(event?.target?.value);
                    }}
                    fullWidth
                  />
                </>
              )}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={6}>
            <Typography sx={{ fontSize: "15px" }}>Scope Seperator</Typography>

            <Controller
              name="scopeSeperator"
              control={control}
              render={({ field, fieldState, formState }) => (
                <Autocomplete
                  autoHighlight={true}
                  size="small"
                  options={SCOPE_SEPERATORS}
                  defaultValue={SCOPE_SEPERATORS[0]}
                  getOptionLabel={(option) => option?.title}
                  disableClearable={true}
                  onChange={(e, value) => {
                    field.onChange(value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      // label="Scope Seperator"
                      required={true}
                    />
                  )}
                />
              )}
            />
          </Grid>
        </Grid>
        <Box mt={2}>
          <Typography sx={{ fontSize: "15px" }}>Scopes</Typography>
          <ul>
            {fields.map((item, index) => (
              <li key={item.id}>
                <Grid container spacing={2} pb={1}>
                  <Grid item xs={5} sm={5} md={5}>
                    <Controller
                      name={`scopes.${index}.displayName`}
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <>
                          <TextField
                            id="standard-basic"
                            size={"small"}
                            variant="outlined"
                            required
                            {...field}
                            onChange={(event) => {
                              field.onChange(event?.target?.value);
                            }}
                            fullWidth
                          />
                        </>
                      )}
                    />
                  </Grid>
                  <Grid item xs={5} sm={5} md={5}>
                    <Controller
                      name={`scopes.${index}.name`}
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <>
                          <TextField
                            id="standard-basic"
                            size={"small"}
                            variant="outlined"
                            required
                            {...field}
                            onChange={(event) => {
                              field.onChange(event?.target?.value);
                            }}
                            fullWidth
                          />
                        </>
                      )}
                    />
                  </Grid>

                  <Grid item xs={2} sm={2} md={2}>
                    <RemoveCircleOutlineIcon
                      sx={{
                        paddingTop: "5px",
                        color: "red",
                        transition: "transform 0.2s", // Smooth transition for zoom effect
                        cursor: "pointer", // Adds pointer cursor on hover
                        "&:hover": {
                          transform: "scale(1.2)", // Scales the icon to 120% on hover
                        },
                      }}
                      onClick={() => remove(index)}
                    />
                    <AddCircleOutlineRoundedIcon
                      sx={{
                        paddingTop: "5px",
                        color: "#1976d2",
                        transition: "transform 0.2s", // Smooth transition for zoom effect
                        cursor: "pointer", // Adds pointer cursor on hover
                        "&:hover": {
                          transform: "scale(1.2)", // Scales the icon to 120% on hover
                        },
                      }}
                      onClick={() => append({ displayName: "", name: "" })}
                    />
                  </Grid>
                </Grid>
              </li>
            ))}
          </ul>
          <Button
            sx={{ textTransform: "none" }}
            variant="contained"
            size="small"
            type="button"
            onClick={() => append({ displayName: "", name: "" })}
          >
            Append
          </Button>
        </Box>

        <Box>
          <Typography mt={1} sx={{ fontSize: "15px" }}>
            Dynamic Parameter
          </Typography>
          <ul>
            {dynamicParamfields.map((item, index) => (
              <li key={item.id}>
                <Grid container spacing={2} mb={1}>
                  <Grid item xs={5} sm={5} md={5}>
                    <Controller
                      name={`dynamicParams.${index}.displayName`}
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <>
                          <TextField
                            id="standard-basic"
                            // label="folder name"
                            size="small"
                            variant="outlined"
                            required
                            {...field}
                            onChange={(event) => {
                              field.onChange(event?.target?.value);
                            }}
                            fullWidth
                          />
                        </>
                      )}
                    />
                  </Grid>
                  <Grid item xs={5} sm={5} md={5}>
                    <Controller
                      name={`dynamicParams.${index}.name`}
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <>
                          <TextField
                            id="standard-basic"
                            // label="folder name"
                            variant="outlined"
                            size="small"
                            required
                            {...field}
                            onChange={(event) => {
                              field.onChange(event?.target?.value);
                            }}
                            fullWidth
                          />
                        </>
                      )}
                    />
                  </Grid>

                  <Grid item xs={2} sm={2} md={2}>
                    <RemoveCircleOutlineIcon
                      sx={{
                        paddingTop: "5px",
                        color: "red",
                        transition: "transform 0.2s", // Smooth transition for zoom effect
                        cursor: "pointer", // Adds pointer cursor on hover
                        "&:hover": {
                          transform: "scale(1.2)", // Scales the icon to 120% on hover
                        },
                      }}
                      onClick={() => dynamicParamRemove(index)}
                    />

                    <AddCircleOutlineRoundedIcon
                      sx={{
                        paddingTop: "5px",
                        color: "#1976d2",
                        transition: "transform 0.2s", // Smooth transition for zoom effect
                        cursor: "pointer", // Adds pointer cursor on hover
                        "&:hover": {
                          transform: "scale(1.2)", // Scales the icon to 120% on hover
                        },
                      }}
                      onClick={() =>
                        dynamicParamAppend({ displayName: "", name: "" })
                      }
                    />
                  </Grid>
                </Grid>
              </li>
            ))}
          </ul>

          <Button
            sx={{ textTransform: "none" }}
            variant="contained"
            size="small"
            onClick={() => dynamicParamAppend({ displayName: "", name: "" })}
          >
            Append
          </Button>
        </Box>
        <div style={{ display: "flex", justifyContent: "end" }}>
          <Button sx={{ marginTop: "10px", mr: 2, color: "#1850A0" }}>
            Cancel
          </Button>
          <Button
            sx={{ marginTop: "10px", bgcolor: "#1976D2" }}
            type="submit"
            variant="contained"
          >
            Create
          </Button>
        </div>
      </form>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Authenticate {service?.name}
          </Typography>
          <OAuth2Authenticator
            serviceAuth={serviceAuth}
            setServiceAuth={setServiceAuth}
            orgId={orgId}
            apiKey={apiKey}
            dataCenter={dataCenter}
            zApiKey={zApiKey}
            setSnack={setSnack}
            service={service}
            currentUser={currentUser}
            submitData={submitData}
            settingId={settingId}
            handlefetchConnections={handlefetchConnections}
          />
        </Box>
      </Modal>
    </Box>
  );
};

export default CustomConnection;
